/*
 * Etérea · Aviso "Entrega solo en Morelia" en el carrito lateral de Kaching.
 * Kaching marca cada línea con data-product-handle; aquí se leen las etiquetas del producto
 * y se marca la línea con data-eterea-morelia. El aviso lo dibuja eterea-kaching-cart.css.
 */
(function () {
  const TAG = 'only morelia';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cacheKey = 'eterea-morelia-tags-v1';
  let cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(cacheKey) || '{}'); } catch (e) { cache = {}; }
  const pending = {};

  function isMorelia(handle) {
    if (handle in cache) return Promise.resolve(cache[handle]);
    if (!pending[handle]) {
      pending[handle] = fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((product) => {
          const tags = product && Array.isArray(product.tags) ? product.tags : [];
          cache[handle] = tags.some((t) => String(t).trim().toLowerCase() === TAG);
          try { sessionStorage.setItem(cacheKey, JSON.stringify(cache)); } catch (e) {}
          return cache[handle];
        })
        .catch(() => false);
    }
    return pending[handle];
  }

  function mark() {
    document.querySelectorAll('.kaching-cart-item[data-product-handle]').forEach((item) => {
      const handle = item.getAttribute('data-product-handle');
      if (!handle || item.getAttribute('data-eterea-morelia-checked') === handle) return;
      item.setAttribute('data-eterea-morelia-checked', handle);
      isMorelia(handle).then((yes) => {
        if (yes) item.setAttribute('data-eterea-morelia', '');
        else item.removeAttribute('data-eterea-morelia');
      });
    });
  }

  let timer = null;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(mark, 80);
  });
  function start() {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-handle'] });
    mark();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
